<template>
	<div>
		
		<div class="r-title">
			<img src="../../assets/imgs/news/news-title-bg.png" class="r-title-bg">
			<span style="z-index: 1;position: relative;">Profile</span>
		</div>
		
		<div>
			 <div>
				<div style="margin-top: 1rem;display: flex;align-items: center;">
					<div :style="{backgroundImage:'url('+avatar+')'}" class="avatar"></div>
					<div>
						<form action="" enctype="multipart/form-data" style="display: none;">
							<input type="file"  multiple="multiple"  accept="image/*" @change="getImg"  id="file"/> 
						</form>
						<div @click="clickFile" style="background-color: #31ffda;color: #000;font-size: 0.7rem;padding: 0.3rem 0.2rem;font-weight: 500;border-radius: 0.2rem;max-width: 8rem;
								display: flex;align-items: center;justify-content: center;cursor: pointer;">Upload new picture</div>
						<div style="color: #999;font-size: 0.7rem;margin-top: 0.5rem;">Min 200*200px,jpg or png.max size of 800kb</div>
					</div>
				</div>
			</div>
			
			<!-- 修改姓名 -->
			<div>
				<div class="box-name">Name</div>
				<input class="box-input" type="text" v-model="name">
			</div>
			<!-- 修改性别 -->
			<div style="position: relative;">
				<div class="box-name">Gender</div>
				<!-- <input class="box-input" type="text" v-model="name"> -->
				<div class="box-input" v-if="gender" @click="genderbox = !genderbox; tagsbox=false;nationbox=false">{{gender.name}}</div>
				<div style="position: absolute;left: 0;top: 5rem;background-color: #f9f9f9;width: 100%;height: fit-content;overflow: scroll; z-index: 997;" class="sel-option" v-if="genderbox">
					<div style="padding:0.2rem 0.5rem;font-size: 1rem;" class="box-option" @click="gender = item;genderbox = false;" v-for="(item, index4) in genderlist" :key="index4">{{item.name}}</div>
				</div>
			</div>
			<!-- 修改国家 -->
			<div style="position: relative;">
				<div class="box-name">Area</div>
				<!-- <input class="box-input" type="text" v-model="name"> -->
				<div class="box-input" @click="nationbox = !nationbox; tagsbox=false;genderbox=false">{{nationitem.englishName}}</div>
				<div style="position: absolute;left: 0;top: 5rem;background-color: #f9f9f9;width: 100%;height: 20rem;overflow: scroll; z-index: 997;" class="sel-option" v-if="nationbox">
					<div style="padding:0.2rem 0.5rem;font-size: 1rem;" class="box-option" @click="nationitem = item;nationbox = false;genderbox=false" v-for="(item, index) in nationdata" :key="index">{{item.englishName}}</div>
				</div>
			</div>
			
			<div>
				<div class="box-name">Register e-mail</div>
				<input class="box-input" type="text" v-model="email">
			</div>
			<div>
				<div class="box-name">Phone number</div>
				<input class="box-input" type="text" v-model="phone">
			</div>
			<div style="margin-top: 1rem;">
				<div style="" class="" style="position: relative;">
					<div style="display: flex;">
						<span class="box-name" style="flex: 1;margin-top: 0;">Label</span>
						<span style="font-size: 0.8rem;color: #666;">less than 5</span>
					</div>
					
					<!-- <input type="text" class="login-input" placeholder="Choose tags" v-model="tags" style="width: 21rem;"> -->
					<div class="box-input tag-box" style="min-height: 2.5rem;display: flex;align-items: center;cursor: pointer;" @click="tagsbox=!tagsbox; nationbox = false;genderbox=false">
						<div class="tag-box-content">
							<div v-for="(tag, index3) in tags" :key="index3" 
									style="background-color: #efefef;display: flex;align-items: center;justify-content: center;margin-right: 0.5rem;margin-bottom: 0.2rem;padding: 0.2rem 0.5rem;min-width: fit-content;">
								{{tag.name}}
								<img src="../../assets/imgs/close-tag.png" style="width: 1rem;height: 1rem;" @click.stop="closetag(index3)">
							</div>
							<img src="../../assets/imgs/user/add.svg" style="width: 1.5rem;height: 1.5rem;cursor: pointer;">
						</div>
					</div>
					<div  style="position: absolute;left: 0;top: 5rem;background-color: #f9f9f9;width: 100%;height: 20rem;overflow: scroll;z-index: 997;" class="sel-option" v-if="tagsbox">
						<div v-for="(item, index2) in tagsdata" :key="index2" v-show="tags.findIndex(key => key.id==item.id )==-1" class="box-option" @click="changetags(item)" style="padding:0.2rem 0.5rem;font-size: 1rem;"><span style="flex: 1;">{{item.label}}</span></div>
					</div>
				</div>
			</div>
			
			<div style="background: linear-gradient(90deg, #31FFDA 0%, #00EDD8 100%);border-radius: 0.2rem;margin-top: 1rem;display: flex;align-items: center;justify-content: center;font-size: 1.2rem;
					margin-top: 3rem;cursor: pointer;border: none;" class="box-input" @click="save">
				save
			</div>
		</div>
	</div>
</template>

<script>
	
		import axios from 'axios'
		import {baseUrl} from '../../assets/js/public.js'
		export default {
			data() {
				return {
					type:0,
					data:{},
					
					avatar: '',
					name:'',
					nationdata:[],
					nationitem: {},
					nationbox:false,
					
					email:'',
					phone:'',
					labelbox:false,
					
					tagsbox:false,
					tagsdata:[],
					tags:[],
					
					genderlist:[{
						name:'secrecy',
						value:1
					},{
						name:'man',
						value:2
					},{
						name:'woman',
						value:3
					}],
					gender:null,
					genderbox:false
				}
			},
			components: {
			},
			methods: {
				save(){
					let tagIds = ''
					for (let i in this.tags) {
						tagIds += this.tags[i].id+','
					}
					// tagIds.slice(1,-1)
					tagIds = tagIds.substring(0, tagIds.length - 1);
					let params = {
						username:this.name,
						mobile:this.phone,
						avatar:this.avatar,
						tagIds:tagIds,
						countryId:this.nationitem.id,
						sex:this.gender.value
					}
					console.info(params)
					
					this.request({
						method: 'post',
						url: '/gci/user/update',
						data:params
					}).then(res => {
						this.getdata()
						// alert(res.msg)
						
						this.$bus.$emit('message', {
							type:2,
							msg:res.msg
						})
					}).catch(error => {
						console.error(error.response)
					})
				},
				clickFile() {
					const input = document.querySelector('#file')
					input.click()
				},
				getImg(e){
					var file = e.target.files;//这个就是选中文件信息
					let formdata = new FormData()
					Array.from(e.target.files).map(item => {
					 console.log(item)
					 formdata.append("file", item)  //将每一个文件图片都加进formdata
				   })
					axios.post(baseUrl+'/upload', formdata).then(res => { 
						console.log(res) 
						this.avatar=res.data.data.url;
					})
				},
				getdata(){
					this.request({
						method: 'get',
						url: '/gci/user/info',
					}).then(res => {
						this.data = res.data
						console.info(this.data)
						this.avatar = this.data.avatar
						this.name = this.data.username
						this.nationitem = this.data.country
						this.tags = this.data.tags
						this.phone = this.data.mobile
						this.email = this.data.email
						
						// 性别
						this.genderlist.findIndex(key => {
							if(key.value==this.data.sex){
								this.gender = key
							}
						})
						// alert(res.msg)
					}).catch(error => {
						console.error(error.response)
					})
				},
				getnationdata(){
					axios({
						method: 'get',
						url: baseUrl + '/gci/country/list',
					}).then(res => {
						this.nationdata = res.data.data.items
						// if(res.data.status!=0){alert(res.data.msg)}
					}).catch(error => {
						console.error(error.response)
					})
				},
				closetag(i){
					// for (let i in this.tags) {
					// 	if(this.tags[i].id==id){
					// 		this.tags.splice(i)
					// 	}
					// }
					this.tags.splice(i, 1)
					this.tagsbox=false
				},
				changetags(obj){
					if(this.tags.length<5){
						this.tags.push(obj)
						this.tagsbox = false
					}else{
						// alert('Select up to 5tags')
						this.$bus.$emit('message', {
							type:1,
							msg:'Select up to 5tags'
						})
					}
				},
				gettagsdata(){
					axios({
						method: 'get',
						url: baseUrl + '/gci/tag',
					}).then(res => {
						let { code, data, message } = res.data
						console.info(data)
						this.tagsdata = data
					}).catch(error => {
						console.error(error.response)
					})
				},
			},
			mounted() {
				this.type = this.$route.query.type
				this.getdata()
				this.getnationdata()
				this.gettagsdata()
				
			}
		}
</script>

<style lang="scss" scoped>
	.box-option:hover{
		background-color: #31ffda;
	}
	.box-name{
		color: #333;font-size: 1rem;margin-top: 1rem;font-weight: bold;
	}
	.box-input{
		border: 1px solid #eee;padding: 0.5rem;background-color: #fff;margin-top: 0.5rem;width: 100%;font-size: 1rem;border-radius: 0.2rem;
		overflow: scroll;
	}
	.box-input::-webkit-scrollbar{display: none;}
	.avatar{
		width:4rem;height: 4rem;background-position: center;background-size: cover;background-repeat: no-repeat;border-radius: 50%;margin-right: 1rem;
	}
	.r-title{
		height: 3rem;
		font-size: 1.5rem;
		font-weight: bold;
		position: relative;
		.r-title-bg{
			width: 13rem;position: absolute;left: -0.5rem;top: -2rem
		}
	}
	.tag-box-content{
		display: flex;flex-wrap: nowrap;width: max-content;align-items: center;
	}
	.sel-option{
		border: 1px solid #000
	}
	.sel-option::-webkit-scrollbar{
		display: none;
	}
</style>